import React from 'react';
import pull = require("lodash/pull");
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {lovLabel, lovValue, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {CONFIGLEVEL} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {MdFieldDto, FieldDefaultTable, FieldValidationTable} from "core/metamodel/metaDomain";
import * as definedRules from 'core/form/rules';
import {DATATYPE} from "core/metamodel/mdField";
import {optionsSearch} from "core/common/service/commonDataService";

interface FieldValidationListProps {
  fieldObject: MdFieldDto;
  rootObject: MdFieldDto;
  entities: ObservableMap<MdEntity>;
  entity: MdEntity;
}

@observer
export default class FieldValidationList extends React.Component<FieldValidationListProps, undefined> {


  @action addValidation = () => {
    console.debug('addValidation');
    const {fieldObject, rootObject} = this.props;
    let newValidation = new FieldValidationTable({
      $new: true,
      $added: true,
      entityName: fieldObject.entityName,
      fieldName: fieldObject.fieldName,
      configLevel: CONFIGLEVEL.GLOBAL
    });
    fieldObject.validations.push(newValidation);
    rootObject.$dirty = true;
  };


  render() {

    const {fieldObject, entities, entity, rootObject} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Field Validations</div>
        <MdIconButton onClick={this.addValidation}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header}  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >
        {
          addSeparator( fieldObject.validations.map((fv, index) => <FieldValidationTableForm dataObject={fv} rootObject={rootObject} key={index}
                                                                                              entities={entities} entity={entity}
                                                                                              index={index} /> ), <MdDivider inset/>)
        }
      </BlockComp>
    );
  }
}


const ParameterFieldComp = ({dataType, ...other}) => {
  switch (dataType) {
    case DATATYPE.NUMBER:
    case DATATYPE.NUMBERCURRENCY:
      return (
        <NumberField {...other} />
      );
    case DATATYPE.STRING:
      return (
        <MdTextField  {...other} maxLength={255}/>
      );
    default :
      return null;
  }
};



const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<FieldValidationTable>) => (
  <div style={{display: 'flex', fontSize: 16, lineHeight: '14px'}}>
    <div className="zz-grey-text zz-mr-5">{lovLabel(dataObject.configLevel)}</div>
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ? <div className="zz-grey-text">{lovLabel(dataObject.tenantGroup)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ? <div className="zz-grey-text">{lovLabel(dataObject.tenant)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ? <div className="zz-grey-text">{lovLabel(dataObject.user)}</div> : null}
    { (dataObject.language) ? <div className="zz-grey-text zz-ml-5">({lovLabel(dataObject.language)})</div> : null}
    { (dataObject.serverSide) ? <div className="zz-grey-text zz-ml-5">server-side</div> : null}
    <div className="zz-ml-10">
      {lovLabel(dataObject.validation)}
      {(dataObject.parameters)? (
        <span className="zz-ml-5">
          (
          {dataObject.parameters.entries().map(([key, value]) => <span key={key} className="zz-ml-2">{key} : {value}</span>)}
          )
        </span>
        ): null}
    </div>
    {(dataObject.qualifyExpr) ? (
        <div className="zz-ml-10">
          {dataObject.qualifyExpr}
        </div>
      ) : null}
  </div>
);

@createForm({
  formName: 'FieldValidationTableForm',
  fields: [{
    name: 'validation'
  }, {
    name: 'tenantGroup',
    validators: ['IsRequired']
  }, {
    name: 'tenant',
    validators: ['IsRequired']
  }, {
    name: 'user',
    validators: ['IsRequired']
  }, {
    name: 'configLevel',
    validators: ['IsRequired']
  }, {
    name: 'language'
  }, {
    name: 'serverSide'
  }, {
    name: 'qualifyExpr'
  }]
}, ClosedContent)
@observer
class FieldValidationTableForm extends React.Component<FormProps<FieldValidationTable, MdFieldDto>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.validations, this.props.dataObject);
  };

  @action handleConfigLevelChange = () => {
    let {dataObject, rootObject, formName} = this.props;
    console.log('handleConfigLevelChange ', dataObject.configLevel);

    dataObject.tenant = null;
    dataObject.tenantGroup = null;
    dataObject.user = null;

    dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
  };


  @action onChangeParameter = (parameterName, value) => {
    if (value != null && value != '') {
      this.props.dataObject.parameters.set(parameterName, value);
    } else {
      this.props.dataObject.parameters.delete(parameterName);
    }
  };

  render() {


    const {dataObject, rootObject, index, entities, formName, entity} = this.props;
    const fields = dataObject.getFormFields(formName);
    let {validation, configLevel, tenantGroup, tenant, user, language, qualifyExpr, serverSide} = fields;

    let parametersDef = null;

    if (dataObject.validation) {
      let validationFunction = definedRules[lovValue(dataObject.validation)];
      if (validationFunction && validationFunction.parameters) {
        parametersDef = validationFunction.parameters;
      }
    }


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...configLevel.props}  />
            <Validate field={configLevel} value={configLevel.props.value} onSuccess={this.handleConfigLevelChange}/>
          </div>

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenantGroup.props}/>
              <Validate field={tenantGroup} value={tenantGroup.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenant.props}/>
              <Validate field={tenant} value={tenant.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...user.props} async loadOptions={optionsSearch.bind(this, 'User', {})} clearable asterixForAll/>
              <Validate field={user} value={user.props.value}/>
            </div>
            : null}

          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...language.props}/>
          </div>

        </div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...validation.props} />
            <Validate field={validation} value={validation.props.value}/>
          </div>
          {(parametersDef) ? (
              Object.entries(parametersDef).map(([key, value]) => (
                <div className="fx col-xs-12 col-sm-4" key={key}>
                  <ParameterFieldComp dataType={value} value={dataObject.parameters.get(key)} name={key} floatingLabelText={key} onChange={this.onChangeParameter.bind(this,key)}/>
                </div>
              ))
            ) : null}
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-8">
            <MdTextField {...qualifyExpr.props} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <MdCheckbox {...serverSide.props}/>
          </div>

        </div>

      </div>
    );


    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/core/metamodel/component/fieldValidationList.tsx